type SerializableRecord = Record<string, string | number | boolean | null | undefined>;

export const normalizeTicker = (symbol: string) => symbol.trim().toUpperCase();

export const queryKeys = {
  me: () => ["me"] as const,
  profile: () => ["profile"] as const,
  entitlements: () => ["entitlements"] as const,
  watches: () => ["watches"] as const,
  watchHistory: (watchId: string) => ["watches", String(watchId), "history"] as const,
  watchContracts: () => ["watches", "contracts"] as const,
  watchConfig: () => ["watches", "config"] as const,
  watchDetail: (watchId: string) => ["watches", String(watchId), "detail"] as const,
  tradeIdeasRoot: () => ["trade-ideas"] as const,
  tradeIdeas: (params: SerializableRecord = {}) => ["trade-ideas", "list", params] as const,
  tradeIdea: (candidateId: string) => ["trade-ideas", "detail", candidateId] as const,
  tradeIdeaSubscriptions: () => ["trade-ideas", "subscriptions"] as const,
  tradeIdeaEditionToday: () => ["trade-ideas", "edition", "today"] as const,
  tradeIdeaEditionByAsOf: (asOf: string) => ["trade-ideas", "edition", "by-as-of", asOf] as const,
  tradeIdeaEditionArchive: (params: SerializableRecord = {}) =>
    ["trade-ideas", "edition", "archive", params] as const,
  watchOptionsSummary: (ticker: string) =>
    ["watches", "options-summary", normalizeTicker(ticker)] as const,
  notificationsRoot: () => ["notifications"] as const,
  notificationPrefs: () => ["notifications", "preferences"] as const,
  briefRoot: () => ["brief"] as const,
  briefToday: () => ["brief", "today"] as const,
  briefHistory: () => ["brief", "history"] as const,
  liveOptions: (params: SerializableRecord = {}) => ["options-flow", "live", params] as const,
  zeroDte: (params: SerializableRecord = {}) => ["options-flow", "zero-dte", params] as const,
  tickerOptions: (symbol: string) => ["ticker", normalizeTicker(symbol), "options-chain"] as const,
  tickerPrice: (symbol: string, timeframe: string) =>
    ["ticker", normalizeTicker(symbol), "price", timeframe] as const,
  tickerSearch: (query: string) => ["ticker-search", query.trim().toUpperCase()] as const,
  tradeIdeaContext: (ledgerId: string) => ["trade-ideas", "idea-context", ledgerId] as const,
  tradeIdeaLedgerRows: (params: SerializableRecord = {}) => ["trade-ideas", "ledger", "rows", params] as const,
  tradeIdeaLedgerPerformance: () => ["trade-ideas", "ledger", "performance"] as const,
  tradeIdeaEditionIntegrity: (asOf: string) => ["trade-ideas", "edition", "integrity", asOf] as const,
  metrics: (range: string) => ["metrics", range] as const,
  metricsAll: (range: string) =>
    [
      "metrics",
      range,
      "all",
    ] as const,
  planDistribution: (rangeKey?: string) =>
    rangeKey
      ? (["metrics", "plan-distribution", rangeKey] as const)
      : (["metrics", "plan-distribution"] as const),
  aiUsage: (range: string, tz?: string) => ["metrics", "ai-usage", range, tz ?? "UTC"] as const,
  aiUsageRecentCalls: (range: string, page: number, pageSize: number) =>
    ["metrics", "ai-usage", "recent-calls", range, page, pageSize] as const,
};
